import React, { useState } from "react";

/**
 * LegacyBanner
 * Dismissible warning banner to indicate the user is in a legacy feature.
 */
const LegacyBanner = ({ className = "" }) => {
  const [open, setOpen] = useState(true);

  if (!open) return null;

  return (
    <div
      className={
        `flex items-center justify-between gap-4 bg-gray-800/80 border border-gray-700 text-gray-300 text-sm rounded-md px-4 py-3 mb-6 backdrop-blur-sm ` +
        className
      }
    >
      <div className="flex items-center gap-2">
        <span className="inline-flex items-center px-2 py-0.5 rounded-full bg-gray-700 text-xs uppercase tracking-wide text-gray-200">
          Legacy
        </span>
        <p>
          You are editing a legacy Brand Profile. New projects should use the
          Dynamic Questionnaire workflow. This tool will be retired soon.
        </p>
      </div>
      <button
        className="text-gray-400 hover:text-gray-200"
        onClick={() => setOpen(false)}
        aria-label="Dismiss legacy notice"
      >
        ×
      </button>
    </div>
  );
};

export default LegacyBanner;